// extracted by mini-css-extract-plugin
export default {"container":"_1-z","list":"a2-z"};